import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let _month;
let _year;
let _salespersonId;
let _company;
let _k_finalizeGrid;

export default function (company, month, year, salespersonId) {
    _month = month;
    _year = year;
    _salespersonId = salespersonId;
    _company = company;

    initGrid();
}

function calculateTotals() {
    const categories = $('.js-category-label').map(function (i, ele) {
        const $e = $(ele);
        return {name: $e.data('category'), display: $e.data('category-display')};
    });
    //  js-commission-total-text
    const data = _k_finalizeGrid.dataSource.data();
    let total = 0.00;
    for (let i = 0; i < categories.length; i++) {
        let catTotal = 0.00;

        const catData = data.filter(e => {
            if (categories[i].name === "New Maint. Agreements" && e.Type.includes("New Maint. Agreements")) {
                return true;
            }
            
            return e.Type === categories[i].name;
        });
        for (let j = 0; j < catData?.length || 0; j++) {
            catTotal += Number(catData[j].CommissionAmount) || 0;
        }
        total += catTotal;
        $(`.${categories[i].display}`).text(kendo.toString(catTotal, 'c2'));
    }
    $('.js-commission-total-text').text(kendo.toString(total, 'c2'));
}

function initGrid() {
    _k_finalizeGrid = $('.js-finalize-grid').kendoGrid({
        dataSource: {
            autoSync: false,
            schema: {
                model: {
                    id: 'entryId',
                    fields: {
                        entryId: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        Month: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        Year: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        MonthDisplay: {
                            type: 'date',
                            editable: false,
                            nullable: false
                        },
                        Company: {
                            type: 'number',
                            editable: false
                        },
                        SalespersonId: {
                            type: 'number',
                            editable: false
                        },
                        SalespersonName: {
                            type: 'string',
                            editable: false
                        },
                        Type: {
                            type: 'string',
                            editable: false
                        },
                        Item: {
                            type: 'string',
                            editable: false
                        },
                        ItemDescription: {
                            type: 'string',
                            editable: false
                        },
                        ItemAmount: {
                            type: 'number',
                            editable: false
                        },
                        ItemGpPercent: {
                            type: 'number',
                            editable: false
                        },
                        CommissionPercentFinal: {
                            type: 'number',
                            editable: false
                        },
                        CommissionPercentOriginal: {
                            type: 'number',
                            editable: false
                        },
                        CommissionAmount: {
                            type: 'number',
                            editable: false
                        },
                        IsException: {
                            type: 'bool',
                            editable: false
                        }
                    }
                }
            },
            transport: {
                read: {
                    dataType: 'json',
                    type: 'GET',
                    url: '/Finance/GetMonthlyExceptions'
                },
                parameterMap(data, type) {
                    if (type === 'read') {
                        data.dateTime = `${_month}/1/${_year}`;
                        data.company = _company;
                    }
                    return data;
                }
            },
            group: {
                field: 'SalespersonName',
                aggregates: [
                    {field: 'CommissionAmount', aggregate: 'sum'}
                ]
            },
            aggregate: [{field: 'CommissionAmount', aggregate: 'sum'}]
        },
        columns: [
            // {
            //     title: 'Month',
            //     field: 'Month',
            //     headerAttributes: {style: 'white-space: normal'},
            //     width: '180px',
            //     template(dataItem) {
            //         return `${dataItem.MonthDisplay}`;
            //     }
            // },
            {
                title: 'SalespersonName',
                field: 'SalespersonName',
                hidden: true,
                headerAttributes: {style: 'white-space: normal'},
                groupHeaderTemplate(dataItem) {
                    return dataItem.value;
                }
            },
            {
                title: 'Commission Type',
                field: 'Type',
                headerAttributes: {style: 'white-space: normal'}
            },
            {
                title: 'Item',
                field: 'Item',
                headerAttributes: {style: 'white-space: normal'}
            },
            // {
            //     title: 'ItemDescription',
            //     field: 'ItemDescription',
            //     headerAttributes: {style: 'white-space: normal'}
            // },
            // {
            //     title: 'ItemAmount',
            //     field: 'ItemAmount',
            //     headerAttributes: {style: 'white-space: normal'}
            // },
            // {
            //     title: 'ItemGpPercent',
            //     field: 'ItemGpPercent',
            //     headerAttributes: {style: 'white-space: normal'}
            // },
            {
                title: 'Commission Percent',
                field: 'CommissionPercentFinal',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    return kendo.toString(dataItem.CommissionPercentFinal, 'p2');
                }
            },
            // {
            //     title: 'CommissionPercentOriginal',
            //     field: 'CommissionPercentOriginal',
            //     headerAttributes: {style: 'white-space: normal'}
            // },
            {
                title: 'Commission Amount',
                field: 'CommissionAmount',
                headerAttributes: {style: 'white-space: normal'},
                aggregates: ['sum'],
                template(dataItem) {
                    return kendo.toString(dataItem.CommissionAmount, 'c2');
                },
                groupFooterTemplate(dataItem) {
                    return kendo.toString(dataItem.CommissionAmount.sum, 'c2');
                }
            },
            {
                title: 'IsException',
                field: 'IsException',
                hidden: true,
                headerAttributes: {style: 'white-space: normal'}
            }
        ],
        dataBound(e) {
            const gridFooter = _k_finalizeGrid.element.find('.k-grid-footer');
            const items = e.sender.items();
            gridFooter.hide();
            items.each(function (i, item) {
                if (e.sender.dataItem(item).IsException) {
                    $(item).addClass('bg-danger-light');
                }
            });
            calculateTotals();
        },
        resizable: false,
        mobile: false,
        scrollable: true,
        sortable: true,
        filterable: {
            operators: {
                string: {
                    contains: 'Contains',
                    startswith: 'Starts with'
                }
            }
        },
        pageable: {
            alwaysVisible: false,
            pageSizes: true,
            buttonCount: 20
        },
        noRecords: {
            template: "There are no exceptions."
        }
    }).data('kendoGrid');
}